// extracted by mini-css-extract-plugin
export default {"overlay":"mAZF70It--Overlay_overlay__mpfM-","overlay-is-active":"mAZF70It--Overlay_overlay-is-active__7819p","overlayIsActive":"mAZF70It--Overlay_overlay-is-active__7819p"};